// AUTH ACTION TYPES
export const LOG_IN_PENDING = 'LOG_IN_pending'
export const LOG_IN_SUCCESS = 'LOG_IN_success'
export const LOG_IN_FAILED = 'LOG_IN_failed'

export const SIGN_OUT_SUCCESS = 'sign_out_success'
export const SIGN_OUT_FAILED = 'sign_out_failed'

export const VERIFY_TOKEN_PENDING = 'verify_token_pending'
export const VERIFY_TOKEN_SUCCESS = 'verify_token_success'
export const VERIFY_TOKEN_FAILED = 'verify_token_failed'

// Open layers types
export const SET_OL_MAP = 'set_ol_map'
export const SET_CHART_CONTAINER_OPEN = 'set_chart_container_open'

export const SET_BASE_MAP_LIST_VISIBLE = 'set_base_map_list_visibly'

export const SET_INFO_BOX_OPEN = 'set_info_box_open'
export const SET_CHENGELOG_BOX_OPEN = 'set_changelog_box_open'

export const SET_MAP_LAYERS = 'set_map_layers'
export const SET_CENTER = 'set_center'
export const SET_BASE_MAP = "set_base_map"
export const ZOOM_IN = 'zoom_in'
export const ZOOM_OUT = 'zoom_out'
export const SET_ZOOM = 'set_zoom'
export const SET_TILE_LOADING = 'set_tile_loading'
export const SET_TILE_LOADED = 'set_tile_loaded'
export const SET_LEGEND_DATA = 'get_legend_data'


export const SET_AREA_DRAWING = 'set_area_drawing'
export const CLEAR_AREA_DRAWING = 'clear_area_drawing'
export const SET_AREA = 'set_area'
export const SET_TYPE = 'set_type'
export const SET_DEFORMATION_RATE_INTERVAL_VALUE = 'SET_DEFORMATION_RATE_INTERVAL_VALUE'

// Points types
export const SET_DOWNLOAD_POINTS_BOX_OPEN = 'set_download_points_box_open'
export const DOWNLOAD_POINTS_PENDING = 'download_points_pending'
export const DOWNLOAD_POINTS_SUCCESS = 'download_points_success'
export const DOWNLOAD_POINTS_FAILED = 'download_points_failed'

export const GET_POINT_VALUE_PENDING = 'get_point_value_pending'
export const GET_POINT_VALUE_SUCCESS = 'get_point_value_success'
export const GET_POINT_VALUE_FAILED = 'get_point_value_failed'

//Measurements
export const GET_MEASUREMENTS_PENDING = 'get_measurements_pending'
export const GET_MEASUREMENTS_SUCCESS = 'get_measurements_success'
export const GET_MEASUREMENTS_FAILED = 'get_measurements_success'
